<template>
  <form class="m-checkout__coupons">
    <div class="m-cart__coupon-input">
      <input class="a-input" :placeholder="t('cart.coupon.placeholder')" v-model="cartStore.couponCode" :disabled="cartStore.cart.coupon !== null">
      <button class="a-btn a-btn--cart" type="button" @click="cartStore.addCoupon(cartStore.couponCode)" v-if="cartStore.cart.coupon === null" >{{ t('cart.button.apply_coupon') }}</button>
      <button v-if="cartStore.cart.coupon !== null" class="a-btn a-btn--cart" type="button"
        :title="t('cart.button.remove_coupon')" @click="cartStore.removeCoupon()">
        <svg class="a-icon a-icon--close" aria-hidden="true">
          <use href="#close" />
        </svg>
      </button>
    </div>
  </form>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useCartStore } from '../../stores/cart';
import { onMounted } from 'vue';

const { t } = useI18n();
const cartStore = useCartStore()

onMounted(async () => {
  await cartStore.init()
})
</script>
